// Reference: https://stackoverflow.com/q/14964035
export const downloadFile = (data: BlobPart[], filename: string, mime?: string) => {
  const blob = new Blob(data, { type: mime ?? 'application/octet-stream' });
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.style.display = 'none';
  link.href = blobUrl;
  link.setAttribute('download', filename);

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
};

// delimiter: semicolon (;)
export const createTextByDelimiterSeparatedValues = (data?: (string | number)[][]): string =>
  data?.map(row => row.map(cell => cell.toString().trim()).join(';')).join('\n') ?? '';

export const readAsText = (blob: Blob, encoding?: string): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result);
    reader.onabort = event => reject(event);
    reader.onerror = event => reject(event);

    reader.readAsText(blob, encoding);
  });
};
